import { AccountModel, ActivityModel, ShippingTruckTypeModel, AddressModel } from "@coreModels";

export class QuoteOrdersModel {
  quote_and_orders?: any;
  project?: any;
  type?: any;
  status?: any;
  status_changed?: any;
  contact?: any;
  account?: any;
  address?: any;
  guest_user_id?: any;
  total_amount?: any;
  slip_rating?: any;
  id?: any;
  guid?: string;
  order_id?: any;
  frontend_user_id?: any;
  delivery_address_id?: any;
  project_name?: string;
  in_shipping_zone?: any;
  subtotal?: any;
  delivery_cost?: any;
  tax_gst?: any;
  applied_credit?: any;
  applied_discount_price?: any;
  final_total?: any;
  quote_status?: any;
  quote_status_name?: string;
  notes?: string;
  warehouse_arrival_date?: string;
  is_archive?: any | null;
  created_at?: any;
  enable_expiry_deadline_at?: any;
  modified_at?: string;
  status_changed_at?: string;
  deliveryAddress?: any;
  quoteProducts?: any; // Delete
  quote_product?: any;
  quoteStatusLog?: any;
  quotePayments?: any;
  frontendUser?: AccountModel;
  backendUser?: AccountModel;
  delivery_instructions?: string;
  note?: string;
  shipping_truck_type_id?: number;
  description?: string;
  is_pushed_bigpost?: any;
  is_expired?: boolean | undefined;
  expire_date?: any;
  leadTime?: any;
  shipping_rate?: any;
  lead_time?: any;
  frontendUserAddresses?: AddressModel;
  available_credit?: any;
  deposit_amount?: any;
  deposit_amount_percentage?: any
  final_due_amount?: any
  final_amount_due?: any;
  final_amount?: any;
  eligible_credit_amount?: any;
  new_credit?: any;
  quoteStatus?: any | null;
  applied_credit_percent?: any;
  order_number?: string;
  quote_number?: string;
  shippingTruckType?: ShippingTruckTypeModel;
  shipping_zone?: any;
  activities?: ActivityModel[]; // delete
  activity?: ActivityModel[];
  total?: any;
  deposit?: any;
  site_contact_name?: string;
  site_contact_number?: string;
  site_contact_email?: string;
  isDepositPaid?: boolean;
  isDepositPaymentPaid?: boolean;
  isPartialPaymentPaid?: boolean;
  isFinalPaymentPaid?: boolean;
  isFullPaymentPaid?: boolean;
  /** Admin override from the console: offer credit card for every payment of this order, whatever the amount. */
  is_credit_card_allowed?: boolean;
  finalAmountDue?: any;
  has_pending_installments?: boolean;
  isShippingCostAdded?: boolean;
  orderStatus?: any;
  quoteFeedback?: any;
  delivery_date?: string;
  no_of_pallet?: any;
  delivery_address_line_1?: string;
  delivery_address_line_2?: string;
  delivery_suburb?: string;
  delivery_town_city?: string;
  delivery_state_region?: string;
  delivery_post_code?: string;
  delivery_country?: string;
  isApproveQuote?: boolean;
  premiumAdhesiveExpand?: boolean;
  premiumSealerExpand?: boolean;
  acceptedActivity?: any;
  progress_bar_width?: any;
  daysToExpiry?: any;
  days_to_expiry?: any; // Delete it
  expiredActivity?: any;
  stock_required_date?: any;
  total_premium_sealing_price?: any = 0;
  total_adhesive_price?: any = 0;
  is_select_premium_sealing?: boolean = false;
  is_select_adhesive?: boolean = false;
  carrier_id?: number
  is_consumable_calculator_applied?: any
  total_applied_calculator_price?: any
  carrier?: any
  is_used_own_transport?: any;
  company?: any;
  is_draft?: any;
  company_address_id?: number;
  frontend_user_address_id?: number;
  total_adhesive_premium_price?: any;
  carrier_status_id?: number;
  export_id?: any;
  amount?: any;
  carrierStatus?: any;
  is_manual_shipping_rate_change?: any;
  isEditableSiteOrderDetails?: any;
  disabledAdhesivePrice?: boolean;
  disabledSealerPriceDefender?: boolean;
  disabledSealerPriceGold?: boolean;
  disabledTotalAdhesivePrice?: boolean;
  disabledTotalPremiumSealingPrice?: boolean;
  is_deleted?: any;
  quoteOverallSealerUnit?: any;
  credit_card_surcharge?: any;
  is_credit_card_charge_show?: any;
  total_adhesive_calculator_price?: any;
  total_sealer_calculator_price?: any;
  is_expiry_disabled?: boolean;
  quote_order_status_detail?: any;
  quoteOrderStatusHistories?: any;
  quoteOrderStatusList?: any;
  is_warehouse_collection?: any;
  frontend_user_bpay_biller_code?: string;
  frontend_user_bpay_reference?: string;
  total_surfaces_and_accessories?: any;
  total_premium_adhesive?: any;
  total_premium_sealing?: any;
  gross_amount?: any;
  applied_discount?: any;
  depositPaidAmount?: any;
  totalPartialPaidAmount?: any;
  total_partial_paid_amount?: any;
  is_deposit_payment_paid?: any;
  deposit_payment_processing?: any;
  final_payment_processing?: any;
  full_payment_processing?: any;
  offline_order_dp_processed?: any;
  is_payment_processing?: boolean;
  is_deposit_slider_adjust?: any;
  total_weight?: any;
  tracking_id?: string;
  is_stock_required_date_confirm?: any
  quoteOrderReactivatedActivities?: any;
  total_rrp_amount?: any;
  trade_discount?: any;
  trade_discount_percentage?: any
  is_select_default_business_address?: any
  credit_specifier_id?: number
  quote_summary?: any;
  frontend_user_quote_frontend_user_idTofrontend_user?: AccountModel;
  quoteOwner?: AccountModel;
  // Sales rep assigned directly on the quote (Unleashed SalesPerson for offline orders)
  backend_user?: any;
  quoteDefaultAddress?: any;
  defaultQuoteAddress?: any;
  quote_address?: any;
  quoteDefaultSiteContact?: any;
  quote_site_contact?: any;
  currentStatusDetail?: any;
  schedulePayments?: any;
  is_split_production?: any;
  is_split_delivery?: any;
  quote_payment?: any;
  isOverChargePaid?: boolean = false;
  isOverCharge?: boolean = false;
  is_offline_order?: boolean = false;
  isDisplayPaymentBtn?: boolean = true;
  is_storage_fee_applicable?: any;
  orderAvailableAtWarehouseActivity: any;
  anticipateWarehouseArrivalDateDetail: any;
  isSRDConflict?: boolean = false;
  isQuoteAccepted?: boolean = false;
  isQuoteCancelled?: boolean = false;
  isOrderCancelled?: boolean = false;
  isQuoteExpired?: boolean = false;
  isQuoteReactivated?: boolean = false;
  isQuoteReactivatedActivity?: boolean = false;
  isQuoteReactivatedActivityCompleted?: boolean = false;
  isQuoteReactivatedActivityPending?: boolean = false;
  isQuoteReactivatedActivityRejected?: boolean = false;
  isQuoteReactivatedActivityApproved?: boolean = false;
  isQuoteReactivatedActivityInProgress?: boolean = false;
  isQuoteReactivatedActivityOnHold?: boolean = false;
  isQuoteReactivatedActivityCancelled?: boolean = false;
  isQuoteReactivatedActivityCompletedApproved?: boolean = false;
  isQuoteReactivatedActivityCompletedRejected?: boolean = false;
  isQuoteReactivatedActivityCompletedInProgress?: boolean = false;
  isQuoteReactivatedActivityCompletedOnHold?: boolean = false;
  isQuoteReactivatedActivityCompletedCancelled?: boolean = false;
  isQuoteReactivatedActivityPendingApproved?: boolean = false;
  isQuoteReactivatedActivityPendingRejected?: boolean = false;
  isQuoteReactivatedActivityPendingInProgress?: boolean = false;
  isQuoteReactivatedActivityPendingOnHold?: boolean = false;
  isQuoteReactivatedActivityPendingCancelled?: boolean = false;
  isQuoteReactivatedActivityRejectedApproved?: boolean = false;
  isQuoteReactivatedActivityRejectedRejected?: boolean = false;
  isQuoteReactivatedActivityRejectedInProgress?: boolean = false;
  isQuoteReactivatedActivityRejectedOnHold?: boolean = false;
  isQuoteReactivatedActivityRejectedCancelled?: boolean = false;
  isQuoteReactivatedActivityApprovedApproved?: boolean = false;
  isQuoteReactivatedActivityApprovedRejected?: boolean = false;
  isQuoteReactivatedActivityApprovedInProgress?: boolean = false;
  isQuoteReactivatedActivityApprovedOnHold?: boolean = false;
  isQuoteReactivatedActivityApprovedCancelled?: boolean = false;
  isQuoteReactivatedActivityInProgressApproved?: boolean = false;
  isQuoteReactivatedActivityInProgressRejected?: boolean = false;
  isQuoteReactivatedActivityInProgressInProgress?: boolean = false;
  isQuoteReactivatedActivityInProgressOnHold?: boolean = false;
  isQuoteReactivatedActivityInProgressCancelled?: boolean = false;
  isQuoteReactivatedActivityOnHoldApproved?: boolean = false;
  isQuoteReactivatedActivityOnHoldRejected?: boolean = false;
  isQuoteReactivatedActivityOnHoldInProgress?: boolean = false;
  isQuoteReactivatedActivityOnHoldOnHold?: boolean = false;
  isQuoteReactivatedActivityOnHoldCancelled?: boolean = false;
  isQuoteReactivatedActivityCancelledApproved?: boolean = false;
  isQuoteReactivatedActivityCancelledRejected?: boolean = false;
  isQuoteReactivatedActivityCancelledInProgress?: boolean = false;
  isQuoteReactivatedActivityCancelledOnHold?: boolean = false;
  isQuoteReactivatedActivityCancelledCancelled?: boolean = false;
  unsettledAmount?: any;
  is_consumable_order?: any;
}
